export const CustomMultiValue = ({ children, selectProps }) => {
  const values = selectProps.value;
  const displayKey = selectProps.getOptionLabel({
    [selectProps.getOptionValue]: values[values.length - 1]?.[selectProps.getOptionValue],
  });
  const isLastValue = displayKey === children;
  return (
    <div>
      {children}
      {!isLastValue && ',\xa0'}
    </div>
  );
};
